<template>
  <v-app class="main-container">
    <!-- V2 SHELL: se muestra solo cuando la ruta inicia con /member-v2 y el flag está activo -->
    <div v-if="isV2Route" class="v2-shell">
      <AppShell />
    </div>

    <v-sheet
      v-else
      class="overflow-hidden"
      style="z-index: 8"
      color="#f9fafc"
      height="100%"
    >
      <landing-navbar
        v-if="
          user &&
          user.role != 'ORGANIZATION' &&
          user.role != 'HEAD_OFFICE' &&
          user.role != 'ORGANIZATION_USER' &&
          user.role != 'BRANCH' &&
          !$route.path.includes('micrositio') &&
          !$route.path.includes('checkout') &&
          !$route.path.includes('member') &&
          !$route.path.includes('matrix') &&
          !$route.path.includes('affiliation-checkout') &&
          !$route.path.includes('credential') &&
          !$route.path.includes('registro') &&
          !$route.path.includes('voucher') &&
          !$route.path.startsWith('/login') &&
          !$route.path.startsWith('/sac/leaderboard') &&
          (!$route.meta.noRedirect ||
            $route.path.includes('facturacion-cliente'))
        "
      />
      <!-- head office nav bar -->
      <dashboard-navbar
        v-if="
          showMainNavbar &&
          !$route.path.startsWith('/login') &&
          !$route.path.includes('micrositio') &&
          !$route.path.includes('credential') &&
          !$route.path.includes('affiliation-checkout') &&
          !$route.path.includes('registro') &&
          !$route.path.includes('voucher') &&
          !$route.meta.noRedirect
        "
      />
      <detail-navbar
        v-if="$route.path.includes('mi-evento') && !$route.meta.noRedirect"
        entityType="Event"
        :navigations="eventsNavigation"
      />
      <!-- member nav var -->
      <side-bar
        v-if="
          $route.path.includes('member') &&
          !$route.path.includes('credential') &&
          !$route.path.includes('micrositio') &&
          !$route.path.includes('affiliation-checkout') &&
          !$route.path.includes('voucher') &&
          $route.name != 'Renew Membership' &&
          $route.name != 'Member new Checkout' &&
          !$route.path.includes('affiliation-profile') &&
          !$route.meta.noRedirect
        "
        :items="membersItems"
      />

      <detail-navbar
        v-if="
          $route.path.includes('mi-membresia') &&
          (user.role !== 'BRANCH' ||
            (branchMembershipAccessChecked && branchMembershipAccessMode))
        "
        entityType="Affiliation"
        :navigations="affiliationNavigationsForUser"
      />
      <detail-navbar
        v-if="
          $route.path.includes('mi-capitulo') && !$route.meta.noRedirect
        "
        entityType="Chapter"
        :navigations="chaptersNavigation"
      />
      <!-- branch nav bar -->
      <BranchNavbar
        v-if="
          user.role == 'BRANCH' &&
          !$route.path.startsWith('/login') &&
          !$route.path.includes('mi-evento') &&
          !$route.path.includes('mi-membresia') &&
          !$route.meta.noRedirect
        "
        entityType="Chapter"
        :navigations="chaptersNavigation"
      />
      <v-main class="bg-color secondary-container">
        <div
          v-if="
            ($route.path === '/member/home' ||
              $route.path === '/member/home/' ||
              $route.path.startsWith('/member/home/showInfo')) &&
            user &&
            (user.role === 'MEMBER' || user.role === 'MEMBERSHIP_USER')
          "
          class="membership-header-wrapper px-4 px-md-16 pt-2"
        >
          <membership-status-header />
        </div>
        <router-view />
      </v-main>
    </v-sheet>
    <!-- ALERTAS DE SITIO -->
    <div class="siteAlerts">
      <BoxAlerts :loggedAccount="user"/>
    </div>
    <!-- Aviso de politica de cookies -->
    <CookiesAdvice></CookiesAdvice>

    <!-- NOTIFICACIONES DEL SITIO -->
    <v-snackbar
      width="400"
      :multi-line="true"
      :top="true"
      :right="true"
      :timeout="time"
      v-model="isVisible"
      :color="color"
      :style="{ zIndex: isV2Route ? 'var(--z-toast)' : '249' }"
      rounded="xl"
      transition="slide-x-reverse-transition"
    >
      <span class="subtitle-2 font-weight-bold">{{ text }}</span>
    </v-snackbar>
    <!-- NOTIFICACIONES DEL SITIO -->
    <!--Inicio de loader del sitio-->
    <v-overlay :value="loaderVisible" :style="{ zIndex: isV2Route ? 'var(--z-modal)' : '250' }">
      <the-loader />
    </v-overlay>
    <!--Fin de loader del sitio-->
    <ScrollToTop />
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import LandingNavbar from "@/components/landing/LandingNavbar";
import LandingFooter from "@/components/landing/LandingFooter";
import DashboardNavbar from "@/components/dashboard/DashboardNavbar";
//import DashboardNavBottom from "@/components/dashboard/DashboardNavBottom";
import DetailNavbar from "@/components/dashboard/DetailNavbar";
import TheLoader from "@/components/shared/TheLoader";
import sideBar from "@/components/memberDashboard/sideBar";
import MembershipStatusHeader from "@/components/memberDashboard/MemberStatusHeader.vue";
import CookiesAdvice from "@/components/shared/CookiesAdvice";
import BranchNavbar from "@/components/dashboard/BranchNavbar";
import { colors } from "@/constants/colors.js";
import BoxAlerts from "./components/shared/BoxAlerts.vue";
import ScrollToTop from "@/components/shared/ScrollToTop.vue";
import { retrieveMemberAffiliationDetails } from "./common/hook/useHelper";
import { isOrganization } from "./share/validateOrganization";
import { getCommunityLabel } from "./share/communityLabel";
import { featureFlags } from "./common/featureFlags";
import {
  canAccessAsocoins,
  canAccessProductServices,
  canAccessVoting,
} from "./common/featureAccess";
import { isAmpiMember } from "./common/memberDashboardRouting";
import AppShell from "./components/memberDashboardV2/shell/AppShell.vue";

export default {
  name: "App",
  components: {
    LandingNavbar,
    LandingFooter,
    DashboardNavbar,
    //DashboardNavBottom,
    DetailNavbar,
    TheLoader,
    MembershipStatusHeader,
    sideBar,
    CookiesAdvice,
    BranchNavbar,
    BoxAlerts,
    ScrollToTop,
    AppShell,
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("member", ["credential"]),
    ...mapState("notification", ["text", "color", "time", "visible"]),
    ...mapState("loader", ["loaderVisible"]),
    ...mapState("alert", ["alertVisible"]),
    affiliationNavigationsForUser() {
      if (
        this.user?.role !== "BRANCH" ||
        this.branchMembershipAccessMode !== "chapter"
      ) return this.affiliationsNavigation;
      return this.affiliationsNavigation
        .filter((navigation) => navigation.name === "tickets-sales-affiliation")
        .map((navigation) => ({ ...navigation, title: "Ventas de Membresías" }));
    },
    isDevEnvironment() {
      return process.env.VUE_APP_ENVIRONMENT === 'development';
    },
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.hide();
      },
    },
    showMainNavbar() {
      //console.log("ROM",this.user)
      if (this.$route.path.startsWith("/login")) return false;
      const routeIncludes = (route) => this.$route.path.includes(route);
      return (
        this.user &&
        (this.user.role === "ORGANIZATION" ||
          this.user.role === "HEAD_OFFICE" ||
          this.user.role === "ORGANIZATION_USER") &&
        !routeIncludes("mi-evento") &&
        !routeIncludes("mi-membresia") &&
        !routeIncludes("mi-capitulo")
      );
    },
    membersItems() {
      if (
        this.user.role === "MEMBERSHIP_USER" ||
        (this.credential &&
          this.credential.credentialInformation &&
          this.credential.credentialInformation.externalId &&
          this.credential.credentialInformation.externalId.substring(0, 2) ===
            "AF")
      ) {
        return this.membershipUsersNavigationComputed;
      } else if (this.user.role === "MEMBER") {
        return this.membersNavigationComputed;
      }
    },
    membersNavigationComputed() {
      // Trabajar sobre una copia evita que el computed agregue Directorio
      // permanentemente al arreglo base cada vez que cambia el usuario.
      let disabledNavigation = [...this.membersNavigation];
      const communityLabel = getCommunityLabel(this.user);
      const withCommunityLabel = (items) => items.map((item) => (
        item.route === "/member/community" ? { ...item, title: communityLabel } : item
      ));
      const { affiliationType: nationalAffiliation } = retrieveMemberAffiliationDetails({ user: this.user, affiliationLevel: "national" });

      if (!this.isDevEnvironment) {
        disabledNavigation = disabledNavigation.filter(
          (item) => !item.devOnly
        );
      }

      // Productos: disponibles en dev y en producción solo para ASOFOM/Canaco León.
      if (!canAccessProductServices(this.user)) {
        disabledNavigation = disabledNavigation.filter((item) => item.route !== "/member/products");
      }
      if (!canAccessVoting(this.user)) {
        disabledNavigation = disabledNavigation.filter((item) => item.route !== "/member/votaciones");
      }
      if (!canAccessAsocoins(this.user)) {
        disabledNavigation = disabledNavigation.filter((item) => !item.asocoinsOnly);
      }

      const orgOwner = this.user?.headOffice && typeof this.user.headOffice === "object"
        ? this.user.headOffice
        : this.user;
      const orgAllowsSubmembers = orgOwner ? orgOwner.allowSubmembers !== false : true;

      if (!!!nationalAffiliation?.enableSublevel || !orgAllowsSubmembers) {
        disabledNavigation = disabledNavigation.filter((item) => item.route !== "/member/affiliates");
      }
      if (this.user.validationStatus === "ACTIVE") {
        const headOfficeId = this.user.headOffice &&
          (typeof this.user.headOffice === "object"
            ? this.user.headOffice._id || this.user.headOffice.id
            : this.user.headOffice);
        if (this.isOrganization(
          "imef",
          this.user._id,
          headOfficeId,
          this.user.organization
        )) {
          if (!disabledNavigation.some((item) => item.route === this.imefUrlMembersNavigation.route)) {
            disabledNavigation.push(this.imefUrlMembersNavigation);
          }
        }
      } else {
        let exludedLinks = ['/member/history', '/member/home', '/member/events', '/member/votaciones', '/member/benefits', '/member-v2/benefits', '/member/community'];
        return withCommunityLabel(disabledNavigation.map((item) => {
          return { ...item, disabled: !exludedLinks.includes(item.route) };
        }));
      }
      return withCommunityLabel(disabledNavigation);
    },
    membershipUsersNavigationComputed() {
      let nav = this.membershipUsersNavigation;
      const communityLabel = getCommunityLabel(this.user);
      if (this.user.validationStatus !== "ACTIVE") {
        nav = nav.map((item) => ({ ...item, disabled: true }));
      }
      if (!this.isDevEnvironment) {
        nav = nav.filter((item) => !item.devOnly);
      }
      // Ocultar Productos y Servicios en entornos distintos a development
      if (!canAccessProductServices(this.user)) {
        nav = nav.filter((item) => item.route !== "/member/products");
      }
      if (!canAccessVoting(this.user)) {
        nav = nav.filter((item) => item.route !== "/member/votaciones");
      }
      if (!canAccessAsocoins(this.user)) {
        nav = nav.filter((item) => !item.asocoinsOnly);
      }
      return nav.map((item) => (
        item.route === "/member/community" ? { ...item, title: communityLabel } : item
      ));
    },
    ableToRenew() {
      //if between today and 90 days before expiration date is true
      const today = new Date();
      const expirationDate = new Date(
        this.user.affiliation.local.details.affiliateInformation.expirationDate
      );
      const ninetyDaysBeforeExpirationDate = new Date(
        expirationDate.setDate(expirationDate.getDate() - 90)
      );
      return (
        today >= ninetyDaysBeforeExpirationDate &&
        this.user.affiliation.local.details.status === "ACTIVE"
      );
    },
    isV2Route() {
      if (!featureFlags.MEMBER_DASHBOARD_V2_ENABLED || isAmpiMember(this.user)) {
        return false;
      }
      const route = this.$route;
      if (!route || typeof route.path !== "string") return false;
      const path = route.path;
      if (path.startsWith("/member-v2")) return true;
      if (path === "/member/home" || path === "/member/home/") return true;
      if (path.startsWith("/member/home/showInfo")) return true;
      // Autodiagnóstico SAC del socio: usar el shell V2 (mismo que member-v2)
      if (
        path === "/sac" ||
        path === "/sac/" ||
        path.startsWith("/sac/responses/")
      ) {
        return true;
      }
      // Leaderboard público de SAC: ruta sin layout (sin shell V2 ni navbars)
      if (path.startsWith("/sac/leaderboard")) {
        return false;
      }
      return false;
    },
  },
  data() {
    return {
      colorPalete: colors,
      branchMembershipAccessMode: null,
      branchMembershipAccessChecked: false,
      loggedIn: false,
      site: "",
      eventsNavigation: [
        //{ icon: 'fas fa-chevron-left', title: 'Volver al inicio', link: '/mis-eventos' },
        //{ icon: 'mdi-view-dashboard', title: 'Panel de evento', name: 'panel-evento' },
        {
          icon: "fas fa-user-friends",
          title: "Asistentes",
          name: "asistentes",
        },
        {
          icon: "far fa-calendar-alt",
          title: "Micrositio",
          name: "micrositio",
        },
        {
          icon: "fas fa-ticket-alt",
          title: "Accesos y ventas",
          name: "tickets-ventas",
        },
        {
          icon: "fas fa-cog",
          title: "Personalización",
          name: "personalization",
        },
      ],
      affiliationsNavigation: [
        //{ icon: "fas fa-user-friends", title: "Miembros", name: "members" },
        {
          icon: "far fa-calendar-alt",
          title: "Micrositio",
          name: "microsite-affiliation",
        },
        {
          icon: "fas fa-ticket-alt",
          title: "Tipos de Membresía y ventas",
          name: "tickets-sales-affiliation",
        },
        {
          icon: "fas fa-cog",
          title: "Personalización",
          name: "affiliation-personalization",
        },
      ],
      chaptersNavigation: [
        {
          icon: "mdi-view-dashboard",
          title: "Panel Local",
          name: "local-panel",
        },
        { icon: "event", title: "Mis Eventos", name: "events" },
        { icon: "badge", title: "Mis Miembros", name: "miembros" },
      ],
      membersNavigation: [
        {
          title: "Inicio",
          icon: "mdi-view-dashboard",
          route: "/member/home",
          disabled: false,
        },
        {
          title: "Histórico y Pagos",
          icon: "mdi-book-open-page-variant",
          route: "/member/history",
          disabled: false,
        },
        {
          title: "Submiembros",
          icon: "mdi-account-multiple",
          route: "/member/affiliates",
          disabled: false,
        },
        {
          title: "Cursos y Eventos",
          icon: "mdi-school",
          route: "/member/events",
          disabled: false,
        },
        {
          title: "Mis Votaciones",
          icon: "mdi-vote-outline",
          route: "/member/votaciones",
          disabled: false,
          prodAsofomOnly: true,
        },
        {
          title: "Mi Comunidad",
          icon: "mdi-radio",
          route: "/member/community",
          disabled: false,
        },
        {
          title: "Mis Beneficios",
          icon: "mdi-hand-coin-outline",
          route: "/member/benefits",
          disabled: false,
        },
        {
          title: "Productos y Servicios",
          icon: "mdi-shopping-outline",
          route: "/member/products",
          disabled: false,
        },
        {
          title: "Academia",
          icon: "mdi-school",
          route: process.env.VUE_APP_ACADEMY_URL || "",
          disabled: false,
          external: true,
          devOnly: true,
        },
      ],
      membershipUsersNavigation: [
        {
          title: "Inicio",
          icon: "mdi-view-dashboard",
          route: "/member/home",
          disabled: false,
        },
        {
          title: "Histórico",
          icon: "mdi-book-open-page-variant",
          route: "/member/history",
          disabled: false,
        },
        {
          title: "Cursos y Eventos",
          icon: "mdi-school",
          route: "/member/events",
          disabled: false,
        },
        {
          title: "Mis Votaciones",
          icon: "mdi-vote-outline",
          route: "/member/votaciones",
          disabled: false,
          prodAsofomOnly: true,
        },
        {
          title: "Mi Comunidad",
          icon: "mdi-radio",
          route: "/member/community",
          disabled: false,
        },
        {
          title: "Mis Beneficios",
          icon: "mdi-hand-coin-outline",
          route: "/member/benefits",
          disabled: false,
        },
        {
          title: "Productos y Servicios",
          icon: "mdi-shopping-outline",
          route: "/member/products",
          disabled: false,
        },
        {
          title: "Academia",
          icon: "mdi-school",
          route: process.env.VUE_APP_ACADEMY_URL || "",
          disabled: false,
          external: true,
          devOnly: true,
        },
      ],
      imefUrlMembersNavigation:
        {
          title: "Directorio",
          icon: "mdi-book-open-page-variant",
          route: "/member/directory", //ID de la afiliacion 67224410633a0427c814fa7e
          disabled: false,
          external: false,
        },
     
    };
  },
  methods: {
    ...mapMutations("notification", ["hide"]),
    ...mapActions("user", [
      "realoadUserData",
      "fetchOrganizationProfilePicture",
      "hydrateAmpiOrganizationContext",
    ]),
    async loadBranchMembershipAccess() {
      if (this.user?.role !== "BRANCH") {
        this.branchMembershipAccessMode = null;
        this.branchMembershipAccessChecked = false;
        return;
      }

      this.branchMembershipAccessChecked = false;
      try {
        const { data } = await this.axios.get("/affiliations/branch-memberships");
        this.branchMembershipAccessMode = data?.mode || null;
      } catch (_) {
        this.branchMembershipAccessMode = null;
      } finally {
        this.branchMembershipAccessChecked = true;
      }
    },
    isOrganization
  },
  watch: {
    "user._id"() {
      this.loadBranchMembershipAccess();
    },
    "user.role"(role) {
      if (role === "ORGANIZATION_USER") {
        this.fetchOrganizationProfilePicture();
      }
      this.loadBranchMembershipAccess();
    },
  },
  async mounted() {
    this.$gtag.screenview({
      app_name: "App",
      screen_name: "Home page",
    });
    this.site = this.$route.fullPath.split("/")[1];
    if (this.user && this.user.email) {
      await this.realoadUserData({ email: this.user.email });
    }
    if (this.user && this.user.role === "ORGANIZATION_USER") {
      await this.fetchOrganizationProfilePicture();
      if (this.user.organization && !this.user.organizationContext) {
        await this.hydrateAmpiOrganizationContext();
      }
    }
    if (this.user?.role === "BRANCH") {
      await this.loadBranchMembershipAccess();
    }
  },
};
</script>
<style>
@import "~shepherd.js/dist/css/shepherd.css";
@import url("https://fonts.googleapis.com/css?family=Montserrat:100,300,400,500,600,700,800,900&display=swap");
@import url("https://fonts.googleapis.com/css?family=Muli:100,300,400,500,700,900&display=swap");

/* V2 — Sistema de diseño (memberDashboardV2) */
@import "./sass/_design-tokens.scss";
@import "./sass/_base.scss";
@import "./sass/_typography.scss";
@import "./sass/_layout.scss";
@import "./sass/_components.scss";
@import "./sass/_utilities.scss";

* {
  font-family: "Montserrat", sans-serif;
}

.siteAlerts {
  position: fixed !important;
  bottom: 0px;
  right: 0px;
  z-index: 10;
}

.primary-variant {
  color: #1b273e;
}

.wc-h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  font-size: 50px;
}

.wc-h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 45px;
}

.wc-h3 {
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  font-size: 30px;
}

.wc-h4 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 30px;
}

.wc-h5 {
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  font-size: 25px;
  letter-spacing: 0.008em;
}

.wc-h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  font-size: 20px;
  letter-spacing: 0.008em;
}

.wc-subtitle-1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 0.009em;
}

.wc-subtitle-2 {
  font-family: "Muli", sans-serif;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.007em;
}

.wc-body-1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.03em;
}

.wc-body-2 {
  font-family: "Muli", sans-serif;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.03em;
}

.wc-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.018em;
}

.wc-caption-1 {
  font-family: "Muli", sans-serif;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.033em;
}

.wc-caption-2 {
  font-family: "Muli", sans-serif;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.033em;
}

.wc-overline {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.15em;
}

.text-primary {
  color: #24b2da !important;
}

.text-primary-variant {
  color: #253656 !important;
}

.text-disabled {
  color: #8c929e !important;
}

.text-active {
  color: #9bf4d5 !important;
}

.text-secondary {
  color: #ffb500 !important;
}

.text-secondary-variant {
  color: #fce09e !important;
}

.text-gray {
  color: #d8d8d8 !important;
}

.text-background {
  color: #f9fafc !important;
}

.text-surface {
  color: #ffffff !important;
}

.text-error {
  color: #fcbd9e !important;
}

.text-contrast-error {
  color: #c46130 !important;
}

.clickable {
  cursor: pointer;
}
</style>
